import * as React from "react";

interface IProps {
    hasPrev: boolean;
    hasNext: boolean;
    onPrevPost: () => void;
    onNextPost: () => void;
}

export default ({ hasPrev, hasNext, onPrevPost, onNextPost }: IProps) => {
    return (
        <div className="CMS_buttonBar">
            <div className="CMS_bbControls">
                <button
                    className="CMS_button CMS_bSimple"
                    disabled={!hasPrev}
                    onClick={async (e) => {
                        e.preventDefault();
                        await onPrevPost();
                    }}
                >
                    <em className="fa fa-arrow-left" aria-hidden="true"></em> Previous post
                </button>&nbsp;
                <button
                    className="CMS_button CMS_bSimple"
                    disabled={!hasNext}
                    onClick={async (e) => {
                        e.preventDefault();
                        await onNextPost();
                    }}
                >
                    Next post&nbsp;
                    <em className="fa fa-arrow-right" aria-hidden="true"></em>
                </button>
            </div>
        </div>
    );
};
